<template>
  <div class="boxType2 progress">
    <slot name="message" />
    <div class="bar">
      <div class="progress-line" :class="{ end: width > 90 }" :style="{ width }"></div>
    </div>
    <p class="bnts">
      <button type="button" class="btn_3"
        @click="onCancelClick">
        <slot name="cancelLabel">{{ $t('common.cancel') }}</slot>
      </button>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: ['width'],
  methods: {
    onCancelClick () {
      this.$emit('onCancelClick')
    }
  }
}
</script>

<style scoped>
.progress  {position:absolute; width: 100%; height:100%; top: 0; left: 0; box-sizing: border-box; padding-top:20px; padding-right: 130px; text-align:center; font-size:13px; font-weight:bold;}
/* .progress  {position:relative; height:125px;  padding-top:20px; text-align:center; font-size:13px; font-weight:bold;} */

.progress > div.bar {position:relative; width:100%; height:8px; margin:15px 0 15px 0 ; border-radius: 4px; overflow:hidden; /* background:#e8e8e8; */}
/* .progress > div.bar div {position:absolute; left:0; top:0; width:0; height:8px; background:#ab47bc} */
.progress > p {text-align:right;}
.progress button {height:28px; line-height:28px; font-size:12px; position: relative; top: -35px; right: -95px;}

.progress-line, .progress-line:before {
  height: 3px;
  width: 100%;
  margin: 0;
}
.progress-line {
  background-color: #b3d4fc;
  display: -webkit-flex;
  display: flex;
  transition: width 5s cubic-bezier(.2,.2,.4,1);
}
.progress-line.end {
   transition-delay: 0.5s;
 }
.progress-line:before {
  background-color: #3f51b5;
  content: '';
  -webkit-animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@-webkit-keyframes running-progress {
  0% { margin-left: 0px; margin-right: 100%; }
  50% { margin-left: 25%; margin-right: 0%; }
  100% { margin-left: 100%; margin-right: 0; }
}
@keyframes running-progress {
  0% { margin-left: 0px; margin-right: 100%; }
  50% { margin-left: 25%; margin-right: 0%; }
  100% { margin-left: 100%; margin-right: 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/global/ProgressBar.vue